import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectCampaignsState = createSelector(getSystem, ({ campaigns }) => campaigns);

export const selectCampaignsList = createSelector(selectCampaignsState, campaigns =>
  _.orderBy(
    Object.values(campaigns?.byId ?? {}),
    ['modifiedDate', 'createdDate'],
    ['desc', 'desc'],
  ),
);

export const selectCampaignById = memoizeOne(campaignId =>
  createSelector(selectCampaignsState, campaigns => campaigns?.byId?.[campaignId] ?? null),
);

export const selectCampaignAudience = createSelector(
  selectCampaignsState,
  campaigns => campaigns?.audience ?? null,
);

export const selectCampaignEnrollments = createSelector(
  selectCampaignsState,
  campaigns => campaigns?.enrollments ?? [],
);
